import { gql } from '@apollo/client';
import client from 'apollo/apolloClient';

/**
 * List method
 * @param  {Object} payload
 * @return {Promise}
 */
const list = (payload) => {
  const { filters, pagination: { first, page } } = payload;
  const authorId = filters.author_id.length > 0 ? `{ column: AUTHOR_ID, operator: IN, value: [ ${filters.author_id} ] }` : '';
  const constructionId = filters.construction_id.length > 0 ? `{ column: CONSTRUCTION_ID, operator: IN, value: [ ${filters.construction_id} ] }` : '';
  const createdAt = filters.created_at ? `createdAt: "${filters.created_at}"` : '';

  const where = `
    where: {
      AND: [
        ${authorId}
        ${constructionId}
      ]
    }
  `;

  return (
    client.query({
      query: gql`
        query materialRefunds($first: Int!, $page: Int!) {
          materialRefunds(
            first: $first
            page: $page
            ${where}
            ${createdAt}
            orderBy: [{
              column: ID
              order: DESC
            }]
          ) {
            paginatorInfo {
              total
              hasMorePages
              lastPage
            }
            data {
              id
              author_id {
                full_name
              }
              construction_id {
                name
              }
              comments
              created_at
              has_pdf
              material_movements {
                material_id {
                  id
                  name
                  unit
                }
                quantity
                value
                iva
                total_value
              }
            }
          }
        }
      `,
      variables: {
        first,
        page,
      },
      fetchPolicy: 'network-only',
    })
  );
};

/**
 * Create material refund method
 * @param  {Object} payload
 * @return {Promise}
 */
const create = (payload) => client.mutate({
  mutation: gql`
    mutation createMaterialRefund($input: CreateMaterialRefundInput!) {
      createMaterialRefund(input: $input) {
        id
      }
    }
  `,
  variables: { input: payload },
});

/**
 * Create pdf method
 * @param  {String} id
 * @return {Promise}
 */
const createPdf = (id) => client.mutate({
  mutation: gql`
    mutation {
      createMaterialRefundPdf(id: ${id})
    }
  `,
});

/**
 * Send created notification method
 * @param  {String} id
 * @return {Promise}
 */
const sendCreatedNotification = (id) => client.mutate({
  mutation: gql`
    mutation {
      sendMaterialRefundCreatedNotification(id: ${id}) {
        sent
        error
      }
    }
  `,
});

/**
 * Get download pdf url method
 * @param  {String} id
 * @return {Promise}
 */
const getDownloadPdfUrl = (id) => client.query({
  query: gql`
    query {
      materialRefundDownloadPdfUrl(id: ${id}) {
        url
      }
    }
  `,
});

export default {
  list,
  create,
  createPdf,
  sendCreatedNotification,
  getDownloadPdfUrl,
};
